<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ContaPagarReceber from '@/src/services/conta-pagar-receber'
import CategoriaConta from '@/src/services/categoria-conta'
import CentroCusto from '@/src/services/centro-custo'
import TipoConta from '@/src/services/tipo-conta'
import produtor from '@/src/services/produtor-rural'
import formProdutor from '@/src/components/form-produtor'
import { VMoney } from 'v-money'
import moment from 'moment'
moment.locale('pt-br')
var currencyFormatter = require('currency-formatter')

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formProdutor },
  directives: { money: VMoney },
  data() {
    return {
      filter: '',
      listStatusFilter: 'todos',
      filterStartDate: '',
      filterEndDate: '',
      filterDebounce: null,
      showAdvancedFilters: false,
      mostraForm: true,
      showHistory: false,
      showFinancialAdjustments: false,
      quickModalType: '',
      quickSupplier: {
        nome: '',
        cpf_cnpj: '',
        telefone: '',
        email: '',
        propriedade: '',
      },
      quickCategory: {
        descricao: '',
        ativo: true,
      },
      quickCostCenter: {
        descricao: '',
        ativo: true,
      },
      isLoading: false,
      idDelete: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      accountFrequency: [
        { value: 'semanalmente', text: 'Semanalmente' },
        { value: 'quinzenalmente', text: 'Quinzenalmente' },
        { value: 'mensalmente', text: 'Mensalmente' },
      ],
      numberOccurrences: [
        { value: '1', text: '1 vez' },
        { value: '2', text: '2 vezes' },
        { value: '3', text: '3 vezes' },
        { value: '4', text: '4 vezes' },
        { value: '5', text: '5 vezes' },
        { value: '6', text: '6 vezes' },
        { value: '7', text: '7 vezes' },
        { value: '8', text: '8 vezes' },
        { value: '9', text: '9 vezes' },
        { value: '10', text: '10 vezes' },
        { value: '11', text: '11 vezes' },
        { value: '12', text: '12 vezes' },
      ],
      contasApagar: [],
      resumoPagar: null,
      categoriasConta: [],
      centroCusto: [],
      tiposConta: [],
      produtores: [],
      contaAPagarEdit: {
        frquencySelected: 'mensalmente',
      },
      contasAPagarField: [
        {
          key: 'descricao',
          label: 'Descrição',
          //class: 'size-col-20',
        },
        {
          key: 'fornecedor',
          label: 'Fornecedor',
          //class: 'size-col-20',
        },
        {
          key: 'data_competencia',
          label: 'Competência',
          //class: 'size-col-20',
        },
        {
          key: 'data_vencimento',
          label: 'Vencimento',
          //class: 'size-col-20',
        },
        {
          key: 'valor',
          label: 'Valor',
          //class: 'size-col-20',
        },
        {
          key: 'diff',
          label: 'Status',
          //class: 'size-col-20',
        },
        { key: 'actions', label: '' /*, class: 'size-col-10'*/ },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      rows: 0,
    }
  },
  computed: {
    resumoFornecedor() {
      return this.getOptionLabel(
        this.produtores,
        'id_produtor_rural',
        this.contaAPagarEdit.id_fornecedor || this.contaAPagarEdit.id_cliente,
        'nome',
        'Fornecedor não selecionado'
      )
    },
    resumoCategoria() {
      return this.getOptionLabel(
        this.categoriasConta,
        'id',
        this.contaAPagarEdit.id_categoria,
        'descricao',
        'Categoria não selecionada'
      )
    },
    resumoConta() {
      return this.getOptionLabel(
        this.tiposConta,
        'id',
        this.contaAPagarEdit.id_tipo_conta,
        'tipo',
        'Conta não selecionada'
      )
    },
    resumoVencimento() {
      return this.formatPreviewDate(this.contaAPagarEdit.data_vencimento)
    },
    resumoCompetencia() {
      return this.formatPreviewDate(this.contaAPagarEdit.data_competencia)
    },
    resumoValor() {
      return this.contaAPagarEdit.valor || 'R$ 0,00'
    },
    resumoRecorrencia() {
      if (!this.contaAPagarEdit.repetir) return 'Não repetir'
      const frequency = this.accountFrequency.find(
        (item) => item.value === this.contaAPagarEdit.frquencySelected
      )
      const vezes = this.contaAPagarEdit.vezes || '1'
      return `${frequency ? frequency.text : 'Mensalmente'} por ${vezes} vezes`
    },
    proximoVencimento() {
      if (!this.contaAPagarEdit.data_vencimento) return 'Defina o vencimento'
      const frequency = this.contaAPagarEdit.frquencySelected || 'mensalmente'
      const amount =
        frequency === 'semanalmente'
          ? 7
          : frequency === 'quinzenalmente'
          ? 15
          : 1
      const unit = frequency === 'mensalmente' ? 'month' : 'day'
      return moment
        .utc(this.contaAPagarEdit.data_vencimento)
        .add(amount, unit)
        .format('DD/MM/YYYY')
    },
    diasAteVencimento() {
      if (!this.contaAPagarEdit.data_vencimento) return ''
      const diff = this.diffDate(this.contaAPagarEdit.data_vencimento)
      if (diff === 0) return 'Vence hoje'
      if (diff > 0) return `Em ${diff} ${diff === 1 ? 'dia' : 'dias'}`
      return `${Math.abs(diff)} ${Math.abs(diff) === 1 ? 'dia' : 'dias'} em atraso`
    },
    historyClient() {
      const produtores = Array.isArray(this.produtores) ? this.produtores : []
      return (
        produtores.find(
          (item) =>
            String(this.getPersonId(item)) ===
            String(this.contaAPagarEdit.id_fornecedor || this.contaAPagarEdit.id_cliente)
        ) || {}
      )
    },
    historyRows() {
      const contas = Array.isArray(this.contasApagar) ? this.contasApagar : []
      const supplierId = this.contaAPagarEdit.id_fornecedor || this.contaAPagarEdit.id_cliente
      if (!supplierId) return contas
      return contas.filter(
        (item) =>
          String(item.id_fornecedor || item.id_cliente) === String(supplierId)
      )
    },
    historyTotalPagar() {
      return this.formatMoney(
        this.historyRows
          .filter((item) => !item.pago)
          .reduce((total, item) => total + this.itemFinalNumber(item), 0)
      )
    },
    historyTotalPago() {
      return this.formatMoney(
        this.historyRows
          .filter((item) => item.pago)
          .reduce((total, item) => total + this.itemFinalNumber(item), 0)
      )
    },
    historyTotalAtraso() {
      return this.formatMoney(
        this.historyRows
          .filter((item) => !item.pago && this.diffDate(item.data_vencimento) < 0)
          .reduce((total, item) => total + this.itemFinalNumber(item), 0)
      )
    },
    historyCreditCommitted() {
      return this.historyTotalPagar
    },
    historyLastPayment() {
      const receivedRows = this.historyRows.filter((item) => item.pago)
      if (!receivedRows.length) return '--/--/----'
      const orderedRows = [...receivedRows].sort((a, b) =>
        moment.utc(b.data_recebimento || b.data_vencimento).diff(
          moment.utc(a.data_recebimento || a.data_vencimento)
        )
      )
      return this.formatPreviewDate(
        orderedRows[0].data_recebimento || orderedRows[0].data_vencimento
      )
    },
    receivableRows() {
      return Array.isArray(this.contasApagar) ? this.contasApagar : []
    },
    filteredReceivableRows() {
      const search = this.filter ? this.filter.toLowerCase().trim() : ''
      return this.receivableRows.filter((item) => {
        const status = this.listStatus(item)
        const statusMatches =
          this.listStatusFilter === 'todos' ||
          status.toLowerCase() === this.listStatusFilter
        const content = [
          item.cliente,
          item.fornecedor,
          item.fornecedor_nome,
          item.descricao,
          item.valor,
          item.valor_formatado,
          item.data_vencimento,
          item.id,
        ]
          .join(' ')
          .toLowerCase()
        return statusMatches && (!search || content.includes(search))
      })
    },
    totalPagarDashboard() {
      if (this.resumoPagar && this.resumoPagar.total_a_pagar_formatado) {
        return this.resumoPagar.total_a_pagar_formatado
      }
      return this.formatMoney(
        this.receivableRows
          .filter((item) => !item.pago)
          .reduce((total, item) => total + this.parseMoney(item.valor), 0)
      )
    },
    vencendoHojeDashboard() {
      if (this.resumoPagar && this.resumoPagar.vencendo_hoje_formatado) {
        return this.resumoPagar.vencendo_hoje_formatado
      }
      return this.formatMoney(
        this.receivableRows
          .filter((item) => !item.pago && this.diffDate(item.data_vencimento) === 0)
          .reduce((total, item) => total + this.parseMoney(item.valor), 0)
      )
    },
    vencendoHojeCount() {
      return this.receivableRows.filter(
        (item) => !item.pago && this.diffDate(item.data_vencimento) === 0
      ).length
    },
    atrasadosDashboard() {
      if (this.resumoPagar && this.resumoPagar.atrasados_formatado) {
        return this.resumoPagar.atrasados_formatado
      }
      return this.formatMoney(
        this.receivableRows
          .filter((item) => this.listStatus(item) === 'ATRASADO')
          .reduce((total, item) => total + this.parseMoney(item.valor), 0)
      )
    },
    previsao30Dashboard() {
      if (this.resumoPagar && this.resumoPagar.previsao_proximos_dias_formatado) {
        return this.resumoPagar.previsao_proximos_dias_formatado
      }
      return this.formatMoney(
        this.receivableRows
          .filter((item) => {
            const diff = this.diffDate(item.data_vencimento)
            return !item.pago && diff >= 0 && diff <= 30
          })
          .reduce((total, item) => total + this.parseMoney(item.valor), 0)
      )
    },
  },

  watch: {
    currentPage() {
      this.listando()
    },
    filter() {
      clearTimeout(this.filterDebounce)
      this.filterDebounce = setTimeout(() => {
        this.resetPageAndList()
      }, 500)
    },
    listStatusFilter() {
      this.resetPageAndList()
    },
    filterStartDate() {
      this.resetPageAndList()
    },
    filterEndDate() {
      this.resetPageAndList()
    },
    'contaAPagarEdit.desconto_taxa': function () {
      if (this.contaAPagarEdit.pago) this.calcularValorTotal()
    },
    'contaAPagarEdit.juro_multa': function () {
      if (this.contaAPagarEdit.pago) this.calcularValorTotal()
    },
    'contaAPagarEdit.valor': function () {
      if (this.contaAPagarEdit.pago) this.calcularValorTotal()
    },
    'contaAPagarEdit.pago': function () {
      this.contaAPagarEdit.valor_final = ''
      if (this.contaAPagarEdit.pago) {
        this.contaAPagarEdit.valor_final = this.contaAPagarEdit.valor
        this.showFinancialAdjustments = true
      }
    },
    mostraForm() {
      if (this.mostraForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
    this.handleGet()
  },
  methods: {
    calcularValorTotal() {
      var valor = currencyFormatter.unformat(this.contaAPagarEdit.valor, {
        locale: 'pt-BR',
        code: 'BRL',
      })
      var taxa = currencyFormatter.unformat(
        this.contaAPagarEdit.desconto_taxa,
        {
          locale: 'pt-BR',
          code: 'BRL',
        }
      )
      var multa = currencyFormatter.unformat(
        this.contaAPagarEdit.juro_multa,
        {
          locale: 'pt-BR',
          code: 'BRL',
        }
      )
      var valorCalculado = valor - taxa - multa

      this.contaAPagarEdit.valor_final = currencyFormatter.format(
        valorCalculado,
        {
          locale: 'pt-BR',
          code: 'BRL',
        }
      )
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      CategoriaConta.listar(token)
        .then((resposta) => {
          this.categoriasConta = resposta.data.categorias
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
      CentroCusto.listar(token)
        .then((resposta) => {
          this.centroCusto = resposta.data.centros
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
      TipoConta.listar(token)
        .then((resposta) => {
          this.isLoading = false
          this.tiposConta = resposta.data.tipoContas
        })
        .catch((error) => {
          this.isLoading = false
        })
      produtor
        .listar(token, this.filter)
        .then((resposta) => {
          this.produtores = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.produtores = []
          this.isLoading = false
        })
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    formatPreviewDate(date) {
      if (!date) return '--/--/----'
      const formattedDate = moment.utc(date).format('DD/MM/YYYY')
      return formattedDate !== 'Invalid date' ? formattedDate : date
    },
    getOptionLabel(options, key, value, label, fallback) {
      const selectedOption = options.find(
        (item) => item[key] === value || String(this.getPersonId(item)) === String(value)
      )
      return selectedOption ? selectedOption[label] : fallback
    },
    getPersonId(item) {
      if (!item || typeof item !== 'object') return item
      return item.id_produtor_rural || item.id_fornecedor || item.id_cliente || item.id
    },
    parseMoney(value) {
      if (!value) return 0
      if (typeof value === 'number') return value
      return currencyFormatter.unformat(value, {
        locale: 'pt-BR',
        code: 'BRL',
      })
    },
    formatMoney(value) {
      return currencyFormatter.format(value || 0, {
        locale: 'pt-BR',
        code: 'BRL',
      })
    },
    historyStatus(item) {
      if (item.pago) return 'PAGO'
      if (this.diffDate(item.data_vencimento) < 0) return 'ATRASADO'
      return 'ABERTO'
    },
    listStatus(item) {
      if (item.status) return String(item.status).toUpperCase()
      return this.historyStatus(item)
    },
    statusLabel(item) {
      const status = this.listStatus(item).toLowerCase()
      if (status === 'pago' || status === 'recebido') return 'Pago'
      if (status === 'atrasado') return 'Atrasado'
      if (status === 'cancelado') return 'Cancelado'
      return 'Em aberto'
    },
    listStatusClass(item) {
      return `receivable-list-status is-${this.listStatus(item).toLowerCase()}`
    },
    clientInitials(item) {
      const name = this.supplierName(item)
      return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0))
        .join('')
        .toUpperCase()
    },
    clientCnpj(item) {
      return item.fornecedor_documento || item.cliente_documento || item.cnpj || item.cpf_cnpj || 'Documento nao informado'
    },
    supplierName(item) {
      return item.fornecedor_nome || item.fornecedor || item.cliente_nome || item.cliente || 'Fornecedor nao informado'
    },
    itemValue(item) {
      return item.valor_formatado || this.formatMoney(this.parseMoney(item.valor))
    },
    itemFinalValue(item) {
      return item.valor_final_formatado || this.itemValue(item)
    },
    itemNumber(item) {
      if (item.valor_formatado) return this.parseMoney(item.valor_formatado)
      return this.parseMoney(item.valor)
    },
    itemFinalNumber(item) {
      if (item.valor_final_formatado) return this.parseMoney(item.valor_final_formatado)
      return this.itemNumber(item)
    },
    dueDescription(item) {
      const diff = this.diffDate(item.data_vencimento)
      if (item.pago) return this.formatPreviewDate(item.data_vencimento)
      if (diff === 0) return 'Vence hoje'
      if (diff > 0) return `Em ${diff} ${diff === 1 ? 'dia' : 'dias'}`
      return `Atrasado ${Math.abs(diff)} ${Math.abs(diff) === 1 ? 'dia' : 'dias'}`
    },
    historyStatusClass(item) {
      return `history-status is-${this.historyStatus(item).toLowerCase()}`
    },
    openHistory() {
      this.showHistory = true
    },
    closeHistory() {
      this.showHistory = false
    },
    notifyFeature(message) {
      this.$bvToast.toast(message, {
        variant: 'info',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    exportRows(rows = this.filteredReceivableRows, filename = 'contas-a-pagar.csv') {
      const items = Array.isArray(rows) ? rows : []
      if (!items.length) {
        this.notifyFeature('Nenhum registro disponível para exportar.')
        return
      }
      const headers = ['ID', 'Fornecedor', 'Descrição', 'Vencimento', 'Valor', 'Status']
      const csvRows = items.map((item) =>
        [
          item.id || '',
          this.supplierName(item),
          item.descricao || '',
          this.formatPreviewDate(item.data_vencimento),
          this.itemFinalValue(item),
          this.statusLabel(item),
        ]
          .map((value) => `"${String(value).replace(/"/g, '""')}"`)
          .join(';')
      )
      const blob = new Blob([[headers.join(';'), ...csvRows].join('\n')], {
        type: 'text/csv;charset=utf-8;',
      })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename
      link.click()
      URL.revokeObjectURL(link.href)
    },
    shareHistory() {
      const url = window.location.href
      if (navigator.share) {
        navigator.share({
          title: 'Histórico de Contas a Pagar',
          url,
        }).catch(() => {})
        return
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          this.notifyFeature('Link do histórico copiado.')
        })
        return
      }
      this.notifyFeature('Compartilhamento não disponível neste navegador.')
    },
    openSupplierDetails() {
      if (!this.contaAPagarEdit.id_fornecedor && !this.contaAPagarEdit.id_cliente) {
        this.notifyFeature('Selecione um fornecedor para ver os detalhes.')
        return
      }
      this.goToShortcut('/cadastros/produtores')
    },
    toggleFinancialAdjustments() {
      this.showFinancialAdjustments = true
      this.$set(this.contaAPagarEdit, 'valor_final', this.contaAPagarEdit.valor)
    },
    setRecurrence(value) {
      if (value === 'nao') {
        this.$set(this.contaAPagarEdit, 'repetir', false)
        return
      }
      this.$set(this.contaAPagarEdit, 'repetir', true)
      this.$set(this.contaAPagarEdit, 'frquencySelected', value)
    },
    isRecurrence(value) {
      if (value === 'nao') return !this.contaAPagarEdit.repetir
      return (
        this.contaAPagarEdit.repetir &&
        this.contaAPagarEdit.frquencySelected === value
      )
    },
    setStatus(value) {
      const statusMap = {
        aberto: 'em_aberto',
        pago: 'pago',
        cancelado: 'cancelado',
        atrasado: 'atrasado',
      }
      this.$set(this.contaAPagarEdit, 'pago', value === 'pago')
      this.$set(this.contaAPagarEdit, 'status', statusMap[value] || 'em_aberto')
      if (value === 'pago') this.showFinancialAdjustments = true
    },
    isStatus(value) {
      const current = this.contaAPagarEdit.status || (this.contaAPagarEdit.pago ? 'pago' : 'em_aberto')
      if (value === 'aberto') return current === 'em_aberto' || current === 'pendente'
      return current === value
    },
    resetContaAPagar() {
      this.contaAPagarEdit = {
        frquencySelected: 'mensalmente',
        vezes: '12',
        repetir: false,
        pago: false,
      }
      this.showFinancialAdjustments = false
    },
    diffDate(date) {
      var given = moment.utc(date, 'YYYY-MM-DD')
      var current = moment.utc().startOf('day')
      return moment.duration(given.diff(current)).asDays()
    },
    resetPageAndList() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
        return
      }
      this.listando()
    },
    goToShortcut(path) {
      if (this.$route.path === path) return
      this.$router.push(path).catch(() => {})
    },
    openQuickCreate(type) {
      this.quickModalType = type
      if (type === 'supplier') {
        this.quickSupplier = {
          nome: '',
          cpf_cnpj: '',
          telefone: '',
          email: '',
          propriedade: '',
        }
      }
      if (type === 'category') {
        this.quickCategory = {
          descricao: '',
          ativo: true,
        }
      }
      if (type === 'cost-center') {
        this.quickCostCenter = {
          descricao: '',
          ativo: true,
        }
      }
      this.$bvModal.show('quick-create-payable')
    },
    closeQuickCreate() {
      this.$bvModal.hide('quick-create-payable')
      this.quickModalType = ''
    },
    normalizeCreatedItem(response, list, labelKey, fallbackLabel) {
      const data = response && response.data ? response.data : {}
      const direct =
        data.data ||
        data.produtor ||
        data.produtorRural ||
        data.categoria ||
        data.centro ||
        data.centroCusto ||
        data.item ||
        data
      if (direct && (direct.id || direct.id_produtor_rural || direct.id_cliente)) return direct
      const label = String(fallbackLabel || '').trim().toLowerCase()
      return (Array.isArray(list) ? list : []).find(
        (item) => String(item[labelKey] || '').trim().toLowerCase() === label
      )
    },
    refreshSuppliers() {
      const token = this.$store.state.auth.currentUser.token
      return produtor.listar(token, 1, 100).then((response) => {
        this.produtores = response.data.data || []
        return this.produtores
      })
    },
    handleQuickSupplierSaved(payload) {
      this.refreshSuppliers()
        .then((items) => {
          const created = this.normalizeCreatedItem(
            payload && payload.response,
            items,
            'nome',
            payload && payload.produtor ? payload.produtor.nome : this.quickSupplier.nome
          )
          if (created) {
            this.$set(this.contaAPagarEdit, 'id_fornecedor', this.getPersonId(created))
            this.$set(this.contaAPagarEdit, 'id_cliente', this.getPersonId(created))
          }
          this.closeQuickCreate()
        })
        .catch((error) => this.showApiError(error))
    },
    refreshCategories() {
      const token = this.$store.state.auth.currentUser.token
      return CategoriaConta.listar(token).then((response) => {
        this.categoriasConta = response.data.categorias || []
        return this.categoriasConta
      })
    },
    refreshCostCenters() {
      const token = this.$store.state.auth.currentUser.token
      return CentroCusto.listar(token).then((response) => {
        this.centroCusto = response.data.centros || []
        return this.centroCusto
      })
    },
    saveQuickCreate() {
      const token = this.$store.state.auth.currentUser.token
      if (this.quickModalType === 'supplier') {
        if (!this.quickSupplier.nome) {
          this.notifyFeature('Informe o nome do fornecedor.')
          return
        }
        this.isLoading = true
        produtor
          .salvar(token, {
            ...this.quickSupplier,
            propriedade: this.quickSupplier.propriedade || this.quickSupplier.nome,
          })
          .then((response) => this.refreshSuppliers().then((items) => ({ response, items })))
          .then(({ response, items }) => {
            const created = this.normalizeCreatedItem(response, items, 'nome', this.quickSupplier.nome)
            if (created) {
              this.$set(this.contaAPagarEdit, 'id_fornecedor', this.getPersonId(created))
              this.$set(this.contaAPagarEdit, 'id_cliente', this.getPersonId(created))
            }
            this.$bvToast.toast('Fornecedor cadastrado e selecionado.', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.closeQuickCreate()
          })
          .catch((error) => this.showApiError(error))
          .finally(() => {
            this.isLoading = false
          })
        return
      }

      if (this.quickModalType === 'category') {
        if (!this.quickCategory.descricao) {
          this.notifyFeature('Informe a descrição da categoria.')
          return
        }
        this.isLoading = true
        CategoriaConta.salvar(token, this.quickCategory)
          .then((response) => this.refreshCategories().then((items) => ({ response, items })))
          .then(({ response, items }) => {
            const created = this.normalizeCreatedItem(response, items, 'descricao', this.quickCategory.descricao)
            if (created) this.$set(this.contaAPagarEdit, 'id_categoria', created.id)
            this.$bvToast.toast('Categoria cadastrada e selecionada.', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.closeQuickCreate()
          })
          .catch((error) => this.showApiError(error))
          .finally(() => {
            this.isLoading = false
          })
        return
      }

      if (this.quickModalType === 'cost-center') {
        if (!this.quickCostCenter.descricao) {
          this.notifyFeature('Informe a descrição do centro de custo.')
          return
        }
        this.isLoading = true
        CentroCusto.salvar(token, this.quickCostCenter)
          .then((response) => this.refreshCostCenters().then((items) => ({ response, items })))
          .then(({ response, items }) => {
            const created = this.normalizeCreatedItem(response, items, 'descricao', this.quickCostCenter.descricao)
            if (created) this.$set(this.contaAPagarEdit, 'id_centro_custo', created.id)
            this.$bvToast.toast('Centro de custo cadastrado e selecionado.', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.closeQuickCreate()
          })
          .catch((error) => this.showApiError(error))
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    toggleAdvancedFilters() {
      this.showAdvancedFilters = !this.showAdvancedFilters
    },
    applyAdvancedFilters() {
      this.resetPageAndList()
      this.showAdvancedFilters = false
    },
    clearAdvancedFilters() {
      this.filterStartDate = ''
      this.filterEndDate = ''
      this.listStatusFilter = 'todos'
      this.filter = ''
      this.resetPageAndList()
    },
    listando() {
      const token = this.$store.state.auth.currentUser.token
      const skip = (this.currentPage - 1) * this.perPage
      const filters = {
        skip,
        offset: skip,
        take: this.perPage,
        limit: this.perPage,
        sortBy: 'data_vencimento',
        sortOrder: 'ASC',
      }
      if (this.filter) filters.search = this.filter
      if (this.listStatusFilter !== 'todos') filters.status = this.listStatusFilter
      if (this.filterStartDate) filters.data_inicio = this.filterStartDate
      if (this.filterEndDate) filters.data_fim = this.filterEndDate
      this.isLoading = true
      ContaPagarReceber.listPayables(token, filters)
        .then((resposta) => {
          this.contasApagar = resposta.data.contas || []
          this.rows = resposta.data.total || resposta.data.count || 0
          if (resposta.data.page) {
            this.perPage = resposta.data.page.take || this.perPage
          }
          this.isLoading = false
        })
        .catch((error) => {
          this.showApiError(error)
          this.isLoading = false
        })
      ContaPagarReceber.getPayableSummary(token, { dias: 30 })
        .then((resposta) => {
          this.resumoPagar = resposta.data.resumo || null
        })
        .catch(() => {
          this.resumoPagar = null
        })
    },
    cadastra() {
      if (this.mostraForm === true) {
        this.mostraForm = false
        this.showHistory = false
        if (!this.contaAPagarEdit.id) this.resetContaAPagar()
      } else {
        this.showHistory = false
        this.mostraForm = true
        this.listando()
      }
    },
    salvarENova() {
      this.salvar(true)
    },
    editRegister(categoriaConta) {
      this.contaAPagarEdit = {
        ...categoriaConta,
        id_fornecedor: categoriaConta.id_fornecedor || categoriaConta.id_cliente,
      }
      this.showFinancialAdjustments = Boolean(
        this.contaAPagarEdit.pago ||
          this.contaAPagarEdit.desconto_taxa ||
          this.contaAPagarEdit.juro_multa ||
          this.contaAPagarEdit.valor_final
      )
      this.showHistory = false
      this.mostraForm = false
    },
    apiErrorMessage(erro) {
      const data = erro && erro.response ? erro.response.data : null
      if (data && data.aviso && data.aviso.mensagem) return data.aviso.mensagem
      if (data && data.mensagem) return data.mensagem
      if (data && Array.isArray(data.message)) return data.message.join(', ')
      if (data && data.message) return data.message
      return erro && erro.message ? erro.message : 'Erro inesperado'
    },
    showApiError(erro) {
      this.$bvToast.toast(this.apiErrorMessage(erro), {
        variant: 'danger',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    buildPayablePayload() {
      const conta = { ...this.contaAPagarEdit }
      const moneyFields = ['valor', 'valor_final', 'desconto_taxa', 'juro_multa']
      moneyFields.forEach((field) => {
        if (conta[field] !== undefined && conta[field] !== null && conta[field] !== '') {
          conta[field] = this.parseMoney(conta[field])
        }
      })
      conta.id_fornecedor = this.getPersonId(conta.id_fornecedor || conta.id_cliente)
      conta.id_cliente = conta.id_fornecedor
      conta.status = conta.pago ? 'pago' : conta.status || 'em_aberto'
      if (conta.pago && !conta.data_recebimento) {
        conta.data_recebimento = moment().format('YYYY-MM-DD')
      }
      return conta
    },
    salvar(resetAfterSave = false) {
      const token = this.$store.state.auth.currentUser.token
      const contaAPagar = this.buildPayablePayload()
      if (contaAPagar.id) {
        this.isLoading = true
        return ContaPagarReceber.updatePayable(token, contaAPagar.id, contaAPagar)
          .then((resposta) => {
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            if (resetAfterSave) this.resetContaAPagar()
            this.listando()
            this.isLoading = false
          })
          .catch((erro) => {
            this.showApiError(erro)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.isLoading = true
        return ContaPagarReceber.createPayable(token, contaAPagar)
          .then((resposta) => {
            this.isLoading = false
            this.$bvToast.toast('Salvo com sucesso!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            if (resetAfterSave) this.resetContaAPagar()
            else this.cadastra()
          })
          .catch((erro) => {
            this.showApiError(erro)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idDelete = id
    },
    handleDelete() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      ContaPagarReceber.deleteAccount(token, this.idDelete)
        .then((reposta) => {
          this.$bvToast.toast('Conta excluída', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.isLoading = false
          this.listando()
        })
        .catch((err) => {
          this.$bvModal.hide('modal-delete')
          this.isLoading = false
          this.showApiError(err)
        })
      this.idDelete = null
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-lg-4 col-md-12 mb-2">
            <div class="titulo">
              <i :class="mostraForm ? 'uil uil-money-withdraw' : 'uil uil-import'"></i>
              {{ mostraForm ? 'Contas a Pagar' : 'Nova Conta a Pagar' }}
            </div>
            <div class="subTitulo">
              {{
                mostraForm
                  ? 'Gerencie e acompanhe todas as contas pendentes e pagas.'
                  : 'Cadastre um pagamento, compra ou serviço contratado.'
              }}
            </div>
          </div>
          <div class="col-lg-8 col-md-12">
            <div class="receivable-page-actions">
              <button
                v-if="mostraForm"
                :class="['btn btn-light', { active: showAdvancedFilters }]"
                type="button"
                @click="toggleAdvancedFilters"
              >
                <i class="uil uil-filter"></i>
                Filtros Avançados
              </button>
              <button v-if="mostraForm" class="btn btn-light" type="button" @click="exportRows()">
                <i class="uil uil-export"></i>
                Exportar
              </button>
              <button
                v-if="!mostraForm"
                class="btn btn-light"
                type="button"
                @click="openHistory"
              >
                <i class="uil uil-clock"></i>
                Histórico
              </button>
              <button
                v-if="!mostraForm"
                class="btn btn-light"
                type="button"
                @click="salvarENova"
              >
                <i class="uil uil-plus"></i>
                Salvar e nova
              </button>
              <button
                v-if="!mostraForm"
                class="btn btn-webreceita"
                type="button"
                @click="salvar"
              >
                <i class="uil uil-save"></i>
                Salvar
              </button>
              <button class="btn btn-webreceita" type="button" @click="cadastra">
                <i v-if="mostraForm" class="uil uil-plus"></i>
                <span v-if="mostraForm">Nova Conta</span>
                <span v-else>Visualizar Contas a Pagar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div v-if="mostraForm" class="receivable-dashboard">
        <div class="receivable-kpi-grid">
          <article class="receivable-kpi is-positive">
            <span>Total a pagar</span>
            <strong>{{ totalPagarDashboard }}</strong>
            <small><i class="uil uil-arrow-growth"></i> +12.5% vs mês ant.</small>
          </article>
          <article class="receivable-kpi is-positive">
            <span>Vencendo hoje</span>
            <strong>{{ vencendoHojeDashboard }}</strong>
            <small>{{ vencendoHojeCount }} faturas pendentes</small>
          </article>
          <article class="receivable-kpi is-danger">
            <span>Atrasados</span>
            <strong>{{ atrasadosDashboard }}</strong>
            <small>Atenção necessária</small>
          </article>
          <article class="receivable-kpi">
            <span>Previsão 30 dias</span>
            <strong>{{ previsao30Dashboard }}</strong>
            <small>Fluxo de caixa saudável</small>
          </article>
        </div>

        <section class="receivable-list-card">
          <div class="receivable-table-wrap">
            <table class="receivable-table">
              <thead>
                <tr>
                  <th>Fornecedor</th>
                  <th>Descrição</th>
                  <th>Vencimento</th>
                  <th>Valor</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in filteredReceivableRows" :key="item.id">
                  <td>
                    <div class="receivable-client-cell">
                      <span class="client-avatar">{{ clientInitials(item) }}</span>
                      <div>
                        <strong>{{ supplierName(item) }}</strong>
                        <span>CNPJ:</span>
                        <small>{{ clientCnpj(item) }}</small>
                      </div>
                    </div>
                  </td>
                  <td>{{ item.descricao || 'Conta a pagar' }}</td>
                  <td>
                    <strong :class="{ 'is-danger-text': listStatus(item) === 'ATRASADO' }">
                      {{ formatPreviewDate(item.data_vencimento) }}
                    </strong>
                    <span :class="{ 'is-danger-text': listStatus(item) === 'ATRASADO' }">
                      {{ dueDescription(item) }}
                    </span>
                  </td>
                  <td>
                    <strong>{{ itemValue(item) }}</strong>
                  </td>
                  <td>
                    <span :class="listStatusClass(item)">
                      {{ statusLabel(item) }}
                    </span>
                  </td>
                  <td>
                    <div class="receivable-row-actions">
                      <button
                        v-b-tooltip.hover
                        title="Editar"
                        type="button"
                        @click="editRegister(item)"
                      >
                        <i class="uil uil-edit"></i>
                      </button>
                      <button
                        v-b-tooltip.hover
                        title="Deletar"
                        type="button"
                        @click="modalDelete(item.id)"
                      >
                        <i class="uil uil-trash-alt"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!filteredReceivableRows.length">
                  <td colspan="6" class="receivable-empty">
                    Nenhuma conta a pagar encontrada.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="receivable-list-footer">
            <span>Exibindo {{ filteredReceivableRows.length }} de {{ rows }} resultados</span>
            <b-pagination
              v-model="currentPage"
              size="sm"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </section>

        <div class="receivable-dashboard-bottom">
          <section class="receivable-insight-card">
            <span class="insight-icon"><i class="uil uil-lightbulb-alt"></i></span>
            <div>
              <h3>Dica de Gestão</h3>
              <p>
                Contas recorrentes e lembretes automáticos ajudam a manter seu fluxo
                de caixa saudável. Configure o envio automático de boletos e
                notificações de vencimento.
              </p>
              <button type="button" @click="notifyFeature('Configuração de automações ainda não está disponível para este módulo.')">
                Configurar automações
                <i class="uil uil-arrow-right"></i>
              </button>
            </div>
          </section>
          <section class="receivable-shortcuts-panel">
            <h3><i class="uil uil-bolt"></i> Atalhos Rápidos</h3>
            <button type="button" @click="goToShortcut('/cadastros/produtores')">+ Novo fornecedor</button>
            <button type="button" @click="goToShortcut('/cadastros/categoria-conta')">+ Nova categoria</button>
            <button type="button" @click="goToShortcut('/financeiro/conciliacao-bancaria')">+ Conciliação bancária</button>
          </section>
        </div>
      </div>

      <div v-else class="receivable-create">
        <section v-if="showHistory" class="history-screen">
          <div class="history-topbar">
            <div>
              <div class="history-breadcrumb">
                Fornecedores <i class="uil uil-angle-right"></i>
                {{ resumoFornecedor }} <i class="uil uil-angle-right"></i>
                Histórico
              </div>
              <h2>Histórico de Contas a Pagar</h2>
            </div>
            <div class="history-actions">
              <button class="btn btn-light" type="button" @click="closeHistory">
                <i class="uil uil-arrow-left"></i>
                Voltar
              </button>
              <button class="btn btn-light" type="button" @click="shareHistory">
                <i class="uil uil-share-alt"></i>
                Compartilhar
              </button>
              <button class="btn btn-webreceita" type="button" @click="exportRows(historyRows, 'historico-contas-a-pagar.csv')">
                <i class="uil uil-export"></i>
                Exportar Histórico
              </button>
            </div>
          </div>

          <div class="history-client-card">
            <div class="history-client-main">
              <span class="history-company-icon">
                <i class="uil uil-building"></i>
              </span>
              <div>
                <strong>{{ resumoFornecedor }}</strong>
                <span>CNPJ: {{ historyClient.cnpj || '12.345.678/0001-99' }}</span>
                <small>
                  <i class="uil uil-envelope"></i>
                  {{ historyClient.email || 'contato@fornecedor.com.br' }}
                  <i class="uil uil-phone ml-2"></i>
                  {{ historyClient.telefone || '(11) 4002-8922' }}
                </small>
              </div>
            </div>
            <div class="history-client-metrics">
              <div>
                <span>Relação financeira</span>
                <strong class="is-good">Excelente</strong>
                <small>Bom histórico de pagamento</small>
              </div>
              <div>
                <span>Atraso médio</span>
                <strong>2.4 dias</strong>
                <small>Últimos 12 meses</small>
              </div>
              <div>
                <span>Último pagamento</span>
                <strong>{{ historyLastPayment }}</strong>
                <small>{{ historyTotalPago }}</small>
              </div>
            </div>
          </div>

          <div class="history-kpis">
            <article>
              <span><i class="uil uil-invoice"></i> +4.2%</span>
              <small>Total a Pagar</small>
              <strong>{{ historyTotalPagar }}</strong>
            </article>
            <article>
              <span class="is-positive"><i class="uil uil-check-circle"></i> +12.8%</span>
              <small>Total pago</small>
              <strong>{{ historyTotalPago }}</strong>
            </article>
            <article>
              <span class="is-negative"><i class="uil uil-exclamation-triangle"></i> -2.1%</span>
              <small>Em Atraso</small>
              <strong class="is-danger">{{ historyTotalAtraso }}</strong>
            </article>
            <article>
              <span><i class="uil uil-wallet"></i> Em aberto</span>
              <small>Crédito comprometido</small>
              <strong>{{ historyCreditCommitted }}</strong>
            </article>
          </div>

          <div class="history-filters">
            <div class="history-search">
              <i class="uil uil-search"></i>
              <input type="text" placeholder="Buscar por número da fatura ou serviço" />
            </div>
            <input type="text" placeholder="dd/mm/aaaa" />
            <span>até</span>
            <input type="text" placeholder="dd/mm/aaaa" />
            <select>
              <option>Todos Status</option>
              <option>Aberto</option>
              <option>Pago</option>
              <option>Atrasado</option>
            </select>
            <button type="button" @click="notifyFeature('Use os filtros avançados da listagem para refinar as contas.')"><i class="uil uil-filter"></i></button>
          </div>

          <section class="history-table-card">
            <div class="history-table-head">
              <h3><i class="uil uil-list-ul"></i> Lançamentos Recentes</h3>
              <span>Exibindo {{ historyRows.length }} de {{ rows }} resultados</span>
            </div>
            <div class="history-table-wrap">
              <table class="history-table">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Descrição</th>
                    <th>Valor Original</th>
                    <th>Saldo Devido</th>
                    <th>Vencimento</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in historyRows" :key="item.id">
                    <td>{{ formatPreviewDate(item.data_competencia) }}</td>
                    <td>
                      <strong>Fatura #{{ item.id }}</strong>
                      <span>{{ item.descricao || 'Conta a pagar' }}</span>
                    </td>
                    <td>{{ itemValue(item) }}</td>
                    <td :class="{ 'is-danger': historyStatus(item) === 'ATRASADO' }">
                      {{ item.pago ? 'R$ 0,00' : itemFinalValue(item) }}
                    </td>
                    <td>{{ formatPreviewDate(item.data_vencimento) }}</td>
                    <td>
                      <span :class="historyStatusClass(item)">
                        {{ statusLabel(item) }}
                      </span>
                    </td>
                    <td>
                      <button type="button" class="history-more" @click="editRegister(item)">
                        <i class="uil uil-ellipsis-v"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!historyRows.length">
                    <td colspan="7" class="history-empty">
                      Nenhum lançamento encontrado para este fornecedor.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="history-footer">
              <span>Linhas por página: 10</span>
              <span>1-{{ historyRows.length }} de {{ historyRows.length }}</span>
            </div>
          </section>

          <div class="history-send-actions">
            <button class="btn btn-webreceita" type="button" @click="notifyFeature('Envio via WhatsApp ainda não está configurado.')">
              <i class="uil uil-whatsapp"></i>
              Enviar comprovante via WhatsApp
            </button>
            <button class="btn btn-light" type="button" @click="notifyFeature('Envio por e-mail ainda não está configurado.')">
              <i class="uil uil-envelope"></i>
              Enviar por e-mail
            </button>
          </div>
        </section>

        <b-form v-else>
          <div class="receivable-grid">
            <main class="receivable-main">
              <section class="receivable-section">
                <h2><i class="uil uil-clipboard-notes"></i> 1. Informações Gerais</h2>
                <b-form-group label="Descrição *">
                  <b-form-input
                    v-model="contaAPagarEdit.descricao"
                    placeholder="Ex.: Venda de defensivos agrícolas"
                  />
                </b-form-group>
                <div class="receivable-form-grid two-cols">
                  <b-form-group label="Fornecedor *">
                    <div class="input-with-action">
                      <v-select
                        class="style-select"
                        label="nome"
                        :options="produtores"
                        :reduce="getPersonId"
                        v-model="contaAPagarEdit.id_fornecedor"
                        placeholder="Digite para buscar o fornecedor..."
                        :dense="true"
                      ></v-select>
                      <button class="btn btn-light" type="button" @click="openQuickCreate('supplier')">
                        <i class="uil uil-plus"></i>
                        Novo
                      </button>
                    </div>
                  </b-form-group>
                  <b-form-group label="Categoria *">
                    <v-select
                      class="style-select"
                      label="descricao"
                      :options="categoriasConta"
                      :reduce="(item) => item.id"
                      v-model="contaAPagarEdit.id_categoria"
                      placeholder="Selecione a categoria"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                  <b-form-group label="Centro de Custo">
                    <v-select
                      class="style-select"
                      label="descricao"
                      :options="centroCusto"
                      :reduce="(item) => item.id"
                      v-model="contaAPagarEdit.id_centro_custo"
                      placeholder="Selecione o centro de custo"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                  <b-form-group label="Tags">
                    <b-form-input placeholder="Adicionar tag" />
                  </b-form-group>
                </div>
              </section>

              <section class="receivable-section">
                <h2><i class="uil uil-money-bill"></i> 2. Financeiro</h2>
                <div class="receivable-form-grid two-cols">
                  <b-form-group label="Competência *">
                    <b-form-datepicker
                      id="datepicker-competencia"
                      v-model="contaAPagarEdit.data_competencia"
                      placeholder=""
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                  </b-form-group>
                  <b-form-group label="Vencimento *">
                    <b-form-datepicker
                      id="datepicker-vencimento"
                      v-model="contaAPagarEdit.data_vencimento"
                      placeholder=""
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                    <span v-if="diasAteVencimento" class="field-hint">{{ diasAteVencimento }}</span>
                  </b-form-group>
                  <b-form-group label="Conta Bancária *">
                    <v-select
                      class="style-select"
                      label="tipo"
                      :options="tiposConta"
                      :reduce="(item) => item.id"
                      v-model="contaAPagarEdit.id_tipo_conta"
                      placeholder="Selecione a conta"
                      :dense="true"
                    ></v-select>
                  </b-form-group>
                  <b-form-group label="Valor *">
                    <div class="value-row">
                      <b-form-input
                        v-model.lazy="contaAPagarEdit.valor"
                        v-money="money"
                      />
                      <button class="btn btn-light" type="button" @click="toggleFinancialAdjustments">
                        <i class="uil uil-plus"></i>
                        Juros/Multa
                      </button>
                    </div>
                  </b-form-group>
                </div>
                <div class="receivable-form-grid four-cols" v-show="contaAPagarEdit.pago || showFinancialAdjustments">
                  <b-form-group label="Data de pagamento">
                    <b-form-datepicker
                      id="datepicker-recebimento"
                      v-model="contaAPagarEdit.data_recebimento"
                      placeholder=""
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                  </b-form-group>
                  <b-form-group label="Desconto / Taxas">
                    <b-form-input v-model.lazy="contaAPagarEdit.desconto_taxa" v-money="money" />
                  </b-form-group>
                  <b-form-group label="Juros / Multa">
                    <b-form-input v-model.lazy="contaAPagarEdit.juro_multa" v-money="money" />
                  </b-form-group>
                  <b-form-group label="Valor Final">
                    <b-form-input disabled class="bg-light" v-model="contaAPagarEdit.valor_final" />
                  </b-form-group>
                </div>
              </section>

              <div class="receivable-split">
                <section class="receivable-section">
                  <h2><i class="uil uil-sync"></i> 3. Recorrência</h2>
                  <div class="radio-list">
                    <button
                      type="button"
                      :class="['radio-row', { active: isRecurrence('nao') }]"
                      @click="setRecurrence('nao')"
                    >
                      <span></span> Não repetir
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isRecurrence('mensalmente') }]"
                      @click="setRecurrence('mensalmente')"
                    >
                      <span></span> Mensal
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isRecurrence('semanalmente') }]"
                      @click="setRecurrence('semanalmente')"
                    >
                      <span></span> Semanal
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isRecurrence('quinzenalmente') }]"
                      @click="setRecurrence('quinzenalmente')"
                    >
                      <span></span> Quinzenal
                    </button>
                  </div>
                  <div class="recurrence-box" v-show="contaAPagarEdit.repetir">
                    <label>Repetir por</label>
                    <div class="repeat-inline">
                      <b-form-select
                        v-model="contaAPagarEdit.vezes"
                        :options="numberOccurrences"
                      ></b-form-select>
                      <span>vezes</span>
                    </div>
                    <p>Próximo vencimento: {{ proximoVencimento }}</p>
                  </div>
                </section>

                <section class="receivable-section">
                  <h2><i class="uil uil-flag"></i> 4. Status</h2>
                  <div class="radio-list">
                    <button
                      type="button"
                      :class="['radio-row', { active: isStatus('aberto') }]"
                      @click="setStatus('aberto')"
                    >
                      <span></span> Em aberto
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isStatus('pago') }]"
                      @click="setStatus('pago')"
                    >
                      <span></span> Pago
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isStatus('cancelado') }]"
                      @click="setStatus('cancelado')"
                    >
                      <span></span> Cancelado
                    </button>
                    <button
                      type="button"
                      :class="['radio-row', { active: isStatus('atrasado') }]"
                      @click="setStatus('atrasado')"
                    >
                      <span></span> Atrasado
                    </button>
                  </div>
                </section>
              </div>

              <section class="receivable-section">
                <h2><i class="uil uil-comment-alt-lines"></i> 5. Observações</h2>
                <b-form-textarea
                  id="textarea"
                  v-model="contaAPagarEdit.obs"
                  placeholder="Informações adicionais, instruções, observações..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </section>

              <div class="receivable-split">
                <section class="receivable-section">
                  <h2><i class="uil uil-paperclip"></i> Anexos</h2>
                  <label class="upload-drop">
                    <i class="uil uil-cloud-upload"></i>
                    <span>Arraste arquivos aqui ou clique para selecionar</span>
                    <small>PDF, JPG, PNG até 10MB cada</small>
                    <input type="file" multiple @change="notifyFeature('Upload de anexos será enviado quando o backend disponibilizar o endpoint de arquivos.')" />
                  </label>
                </section>

                <section class="receivable-section">
                  <h2><i class="uil uil-message"></i> Pagamento automático</h2>
                  <p class="section-subtitle">Enviar lembretes automáticos deste pagamento</p>
                  <div class="reminder-options">
                  <b-form-checkbox checked @change="notifyFeature('Lembretes automáticos ainda não estão integrados ao backend.')">WhatsApp</b-form-checkbox>
                  <b-form-checkbox checked @change="notifyFeature('Lembretes automáticos ainda não estão integrados ao backend.')">E-mail</b-form-checkbox>
                  </div>
                  <div class="reminder-row">
                    <label>Enviar lembrete</label>
                    <b-form-select
                      :options="[
                        { value: '3', text: '3 dias antes do vencimento' },
                        { value: '5', text: '5 dias antes do vencimento' },
                        { value: '7', text: '7 dias antes do vencimento' },
                      ]"
                      value="3"
                    ></b-form-select>
                  </div>
                </section>
              </div>
            </main>

            <aside class="receivable-aside">
              <section class="receivable-section summary-card">
                <h2><i class="uil uil-clipboard-notes"></i> Resumo do Pagamento</h2>
                <div class="summary-item">
                  <span>Fornecedor</span>
                  <strong>{{ resumoFornecedor }}</strong>
                  <button type="button" @click="openSupplierDetails">Ver detalhes</button>
                </div>
                <div class="summary-item">
                  <span>Descrição</span>
                  <strong>{{ contaAPagarEdit.descricao || 'Descrição não informada' }}</strong>
                </div>
                <div class="summary-item">
                  <span>Valor</span>
                  <strong class="summary-value">{{ resumoValor }}</strong>
                </div>
                <div class="summary-dates">
                  <div>
                    <span>Vencimento</span>
                    <strong><i class="uil uil-calendar-alt"></i> {{ resumoVencimento }}</strong>
                    <small v-if="diasAteVencimento">{{ diasAteVencimento }}</small>
                  </div>
                  <div>
                    <span>Competência</span>
                    <strong><i class="uil uil-calendar-alt"></i> {{ resumoCompetencia }}</strong>
                  </div>
                </div>
                <div class="summary-item">
                  <span>Conta Bancária</span>
                  <strong>{{ resumoConta }}</strong>
                </div>
                <div class="summary-item">
                  <span>Status</span>
                  <b-badge :variant="contaAPagarEdit.pago ? 'primary' : contaAPagarEdit.status === 'cancelado' ? 'secondary' : contaAPagarEdit.status === 'atrasado' ? 'danger' : 'success'">
                    {{ contaAPagarEdit.pago ? 'Pago' : contaAPagarEdit.status === 'cancelado' ? 'Cancelado' : contaAPagarEdit.status === 'atrasado' ? 'Atrasado' : 'Em aberto' }}
                  </b-badge>
                </div>
                <div class="summary-item">
                  <span>Recorrência</span>
                  <strong>{{ resumoRecorrencia }}</strong>
                </div>
                <div class="summary-item">
                  <span>Categoria</span>
                  <strong>{{ resumoCategoria }}</strong>
                </div>
              </section>

              <section class="receivable-tip">
                <h3><i class="uil uil-lightbulb-alt"></i> Dica</h3>
                <p>Contas recorrentes e lembretes automáticos ajudam a manter seu fluxo de caixa saudável.</p>
              </section>

              <section class="receivable-section shortcuts-card">
                <h2><i class="uil uil-bolt"></i> Atalhos</h2>
                <button type="button" @click="openQuickCreate('supplier')"><i class="uil uil-plus"></i> Novo fornecedor</button>
                <button type="button" @click="openQuickCreate('category')"><i class="uil uil-plus"></i> Nova categoria</button>
                <button type="button" @click="openQuickCreate('cost-center')"><i class="uil uil-plus"></i> Novo centro de custo</button>
              </section>
            </aside>
          </div>
        </b-form>
      </div>
    </div>

    <div
      v-if="showAdvancedFilters"
      class="receivable-filter-overlay"
      @click="toggleAdvancedFilters"
    ></div>
    <aside v-if="showAdvancedFilters" class="receivable-filter-drawer" aria-label="Filtros">
      <header class="receivable-filter-head">
        <div>
          <strong>Filtros avançados</strong>
          <span>Refine as contas a pagar exibidas na lista.</span>
        </div>
        <button
          class="receivable-filter-close"
          type="button"
          aria-label="Fechar filtros"
          @click="toggleAdvancedFilters"
        >
          <i class="uil uil-times"></i>
        </button>
      </header>
      <div class="receivable-filter-body">
        <label class="receivable-filter-field">
          Busca
          <div class="receivable-search">
            <i class="uil uil-search"></i>
            <input v-model="filter" type="text" placeholder="Fornecedor, descrição ou valor" />
          </div>
        </label>
        <label class="receivable-filter-field">
          Status
          <select v-model="listStatusFilter">
            <option value="todos">Todos os Status</option>
            <option value="em_aberto">Em aberto</option>
            <option value="atrasado">Atrasado</option>
            <option value="pago">Pago</option>
            <option value="cancelado">Cancelado</option>
          </select>
        </label>
        <label class="receivable-filter-field">
          Data inicial
          <input v-model="filterStartDate" type="date" />
        </label>
        <label class="receivable-filter-field">
          Data final
          <input v-model="filterEndDate" type="date" />
        </label>
      </div>
      <footer class="receivable-filter-actions">
        <button class="btn btn-light" type="button" @click="clearAdvancedFilters">
          Limpar filtros
        </button>
        <button class="btn btn-primary" type="button" @click="applyAdvancedFilters">
          Aplicar filtros
        </button>
      </footer>
    </aside>

    <b-modal
      id="quick-create-payable"
      :title="
        quickModalType === 'supplier'
          ? 'Novo fornecedor'
          : quickModalType === 'category'
          ? 'Nova categoria'
          : 'Novo centro de custo'
      "
      title-class="font-18"
      hide-footer
      centered
      scrollable
      size="xl"
    >
      <div>
        <form-produtor
          v-if="quickModalType === 'supplier'"
          :produtor="quickSupplier"
          @saved="handleQuickSupplierSaved"
        />

        <div v-if="quickModalType === 'category'" class="quick-create-grid">
          <b-form-group label="Descrição *">
            <b-form-input
              v-model="quickCategory.descricao"
              placeholder="Informe a categoria"
              autofocus
            />
          </b-form-group>
          <b-form-group label="Ativo">
            <b-form-checkbox v-model="quickCategory.ativo" switch>
              Categoria ativa
            </b-form-checkbox>
          </b-form-group>
        </div>

        <div v-if="quickModalType === 'cost-center'" class="quick-create-grid">
          <b-form-group label="Descrição *">
            <b-form-input
              v-model="quickCostCenter.descricao"
              placeholder="Informe o centro de custo"
              autofocus
            />
          </b-form-group>
          <b-form-group label="Ativo">
            <b-form-checkbox v-model="quickCostCenter.ativo" switch>
              Centro de custo ativo
            </b-form-checkbox>
          </b-form-group>
        </div>

        <div v-if="quickModalType !== 'supplier'" class="quick-create-actions">
          <button class="btn btn-light" type="button" @click="closeQuickCreate">
            Cancelar
          </button>
          <button class="btn btn-webreceita" type="button" @click="saveQuickCreate">
            Salvar e selecionar
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="false"
    ></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 24px;
  background-color: #fff;
  padding: 32px;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
  .titulo {
    align-items: center;
    display: flex;
    font-size: 25px;
    gap: 8px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    background-color: #008e75;
    border-color: #008e75;
    color: #fff;
    padding: 9px 24px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.receivable-page-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;

  .btn {
    align-items: center;
    border-radius: 5px;
    flex: 0 0 auto;
    display: inline-flex;
    font-weight: 600;
    gap: 7px;
    height: 42px;
    justify-content: center;
    margin: 0;
    min-width: 124px;
    padding: 0 18px;
  }

  .btn-light {
    background: #fff;
    border-color: #d8dee8;
    color: #172033;
  }

  .btn-light.active {
    background: #e7f5ef;
    border-color: #008e75;
    color: #008e75;
  }
}

.receivable-dashboard {
  background: #f5f7fb;
  border-radius: 8px;
  display: grid;
  gap: 18px;
  padding: 2px 0 0;
}

.receivable-kpi-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.receivable-kpi {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  display: grid;
  gap: 8px;
  min-height: 118px;
  padding: 18px 20px;

  span {
    color: #172033;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
  }

  strong {
    color: #172033;
    font-size: 24px;
    font-weight: 800;
    line-height: 1.1;
  }

  small {
    color: #536074;
  }

  &.is-positive {
    border-color: rgba(0, 142, 117, 0.65);
  }

  &.is-positive small,
  &.is-positive small i {
    color: #008e75;
  }

  &.is-danger {
    border-color: rgba(220, 53, 69, 0.72);
  }

  &.is-danger strong,
  &.is-danger small {
    color: #dc3545;
  }
}

.receivable-filter-overlay {
  background: rgba(15, 23, 42, 0.38);
  bottom: 0;
  inset: 0;
  left: 0;
  position: fixed !important;
  right: 0;
  top: 0;
  z-index: 3000;
}

.receivable-filter-drawer {
  background: #fff;
  box-shadow: -18px 0 38px rgba(15, 23, 42, 0.18);
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  max-width: 100vw;
  position: fixed !important;
  right: 0;
  top: 0;
  width: 390px;
  z-index: 3010;
}

.receivable-filter-head {
  align-items: flex-start;
  border-bottom: 1px solid #e3e9f2;
  display: flex;
  gap: 14px;
  justify-content: space-between;
  padding: 20px 22px 18px;

  strong {
    color: #172033;
    display: block;
    font-size: 18px;
    font-weight: 800;
  }

  span {
    color: #647084;
    display: block;
    font-size: 13px;
    line-height: 1.4;
    margin-top: 4px;
  }
}

.receivable-filter-close {
  align-items: center;
  background: #f4f7fb;
  border: 1px solid #e0e7f0;
  border-radius: 6px;
  color: #172033;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  min-width: 34px;
  padding: 0;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.receivable-filter-close:hover {
  background: #eaf0f7;
  border-color: #cfd8e5;
}

.receivable-filter-body {
  align-content: start;
  display: grid;
  flex: 1;
  gap: 14px;
  grid-auto-rows: min-content;
  overflow-y: auto;
  padding: 18px 22px 20px;
}

.receivable-filter-field {
  color: #536074;
  display: grid;
  font-size: 12px;
  font-weight: 800;
  gap: 7px;
  margin: 0;

  select,
  input[type='date'] {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 5px;
    color: #172033;
    height: 40px;
    padding: 0 12px;
    width: 100%;
  }
}

.receivable-filter-actions {
  border-top: 1px solid #e3e9f2;
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
  padding: 16px 22px;

  .btn {
    margin: 0;
    min-height: 38px;
  }
}

.receivable-search {
  align-items: center;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  display: flex;
  gap: 8px;
  height: 40px;
  min-width: 0;
  padding: 0 12px;
  width: 100%;

  i {
    color: #647084;
  }

  input {
    border: 0;
    color: #172033;
    flex: 1;
    min-width: 0;
    outline: 0;
  }
}

.receivable-list-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  overflow: hidden;
}

.receivable-table-wrap {
  overflow-x: auto;
}

.receivable-table {
  border-collapse: collapse;
  min-width: 880px;
  width: 100%;

  th {
    background: #eef3fb;
    color: #354158;
    font-size: 12px;
    font-weight: 800;
    padding: 14px 18px;
    text-align: left;
    text-transform: uppercase;
  }

  td {
    border-top: 1px solid #e7edf4;
    color: #172033;
    font-size: 13px;
    padding: 16px 18px;
    vertical-align: middle;
  }

  td > strong {
    display: block;
    font-size: 15px;
    font-weight: 800;
  }

  td > span,
  td small {
    color: #647084;
    display: block;
    margin-top: 3px;
  }
}

.receivable-client-cell {
  align-items: center;
  display: flex;
  gap: 12px;

  strong,
  span,
  small {
    display: block;
  }

  strong {
    color: #172033;
    font-weight: 800;
  }

  span,
  small {
    color: #647084;
  }
}

.client-avatar {
  align-items: center;
  background: #dff6f3;
  border-radius: 50%;
  color: #008e75;
  display: inline-flex;
  flex: 0 0 30px;
  font-size: 11px;
  font-weight: 800;
  height: 30px;
  justify-content: center;
  width: 30px;
}

.is-danger-text {
  color: #dc3545 !important;
}

.receivable-list-status {
  border-radius: 999px;
  display: inline-block;
  font-size: 11px;
  font-weight: 800;
  padding: 4px 9px;

  &.is-aberto {
    background: #e7f5ef;
    color: #008e75;
  }

  &.is-atrasado {
    background: #ffe9ed;
    color: #dc3545;
  }

  &.is-pago {
    background: #f0f1f2;
    color: #536074;
  }
}

.receivable-row-actions {
  display: flex;
  gap: 6px;

  button {
    align-items: center;
    background: transparent;
    border: 0;
    color: #536074;
    display: inline-flex;
    font-size: 18px;
    height: 30px;
    justify-content: center;
    width: 30px;
  }
}

.receivable-empty {
  color: #647084;
  padding: 28px !important;
  text-align: center;
}

.receivable-list-footer {
  align-items: center;
  border-top: 1px solid #e7edf4;
  color: #536074;
  display: flex;
  justify-content: space-between;
  padding: 16px 18px;

  .pagination {
    margin: 0;
  }
}

.receivable-dashboard-bottom {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 2fr) minmax(260px, 1fr);
}

.receivable-insight-card,
.receivable-shortcuts-panel {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  padding: 18px 20px;
}

.receivable-insight-card {
  display: flex;
  gap: 14px;

  h3,
  p {
    margin: 0;
  }

  h3 {
    color: #172033;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 6px;
  }

  p {
    color: #536074;
    line-height: 1.5;
  }

  button {
    background: transparent;
    border: 0;
    color: #008e75;
    font-weight: 700;
    margin-top: 10px;
    padding: 0;
  }
}

.insight-icon {
  align-items: center;
  background: #e7f5ef;
  border-radius: 50%;
  color: #008e75;
  display: inline-flex;
  flex: 0 0 42px;
  font-size: 22px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.receivable-shortcuts-panel {
  border-color: #cfe2ff;

  h3 {
    align-items: center;
    color: #172033;
    display: flex;
    font-size: 15px;
    font-weight: 800;
    gap: 8px;
    margin: 0 0 12px;
  }

  h3 i {
    color: #0f4aa2;
  }

  button {
    background: transparent;
    border: 0;
    color: #008e75;
    display: block;
    font-weight: 700;
    margin-top: 9px;
    padding: 0;
    text-align: left;
  }
}

.receivable-create {
  color: #172033;
}

.receivable-header {
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-bottom: 24px;
}

.receivable-heading {
  align-items: flex-start;
  display: flex;
  gap: 14px;

  h1 {
    color: #172033;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    margin: 0 0 6px;
  }

  p {
    color: #657085;
    font-size: 15px;
    margin: 0;
  }
}

.receivable-heading-icon {
  align-items: center;
  color: #008e75;
  display: inline-flex;
  font-size: 30px;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.receivable-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;

  .btn {
    align-items: center;
    border-radius: 5px;
    display: inline-flex;
    font-weight: 600;
    gap: 8px;
    height: 44px;
    justify-content: center;
    margin: 0;
    min-width: 130px;
    padding: 0 22px;
  }

  .btn-webreceita {
    margin: 0;
  }

  .btn-light {
    background: #fff;
    border-color: #d8dee8;
    color: #172033;
  }
}

.receivable-grid {
  align-items: start;
  display: grid;
  gap: 20px;
  grid-template-columns: minmax(0, 1fr) 360px;
}

.receivable-main {
  display: grid;
  gap: 12px;
}

.receivable-aside {
  display: grid;
  gap: 14px;
  position: sticky;
  top: 88px;
}

.receivable-section,
.receivable-tip {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  padding: 18px 20px;

  h2,
  h3 {
    align-items: center;
    color: #172033;
    display: flex;
    font-size: 16px;
    font-weight: 700;
    gap: 10px;
    margin: 0 0 16px;
  }

  h2 i,
  h3 i {
    color: #008e75;
    font-size: 20px;
  }

  label,
  legend {
    color: #172033;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 7px;
  }

  .form-control,
  .custom-select,
  .vs__dropdown-toggle {
    border-color: #d8dee8;
    border-radius: 5px;
    min-height: 36px;
  }
}

.receivable-form-grid {
  display: grid;
  gap: 16px 18px;

  &.two-cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  &.four-cols {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    margin-top: 12px;
  }
}

.input-with-action,
.value-row {
  align-items: stretch;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) 82px;

  .btn {
    align-items: center;
    border-color: #d8dee8;
    border-radius: 5px;
    display: inline-flex;
    font-weight: 600;
    gap: 6px;
    height: 40px;
    justify-content: center;
    margin: 0;
    padding: 0 12px;
    white-space: nowrap;
  }
}

.value-row {
  grid-template-columns: minmax(0, 1fr) 126px;
}

.field-hint {
  color: #6d7686;
  display: block;
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
}

.receivable-split {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.radio-list {
  display: grid;
  gap: 8px;
}

.radio-row {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 5px;
  color: #243047;
  display: flex;
  gap: 8px;
  min-height: 30px;
  padding: 4px 6px;
  text-align: left;
  transition: background 0.2s ease, color 0.2s ease;

  span {
    border: 1px solid #b7c1cf;
    border-radius: 50%;
    display: inline-block;
    height: 15px;
    position: relative;
    width: 15px;
  }

  &.active span {
    border-color: #008e75;
  }

  &.active {
    background: #ecf8f4;
    color: #008e75;
    font-weight: 700;
  }

  &.active span::after {
    background: #008e75;
    border-radius: 50%;
    content: '';
    height: 7px;
    left: 3px;
    position: absolute;
    top: 3px;
    width: 7px;
  }

  &:hover {
    background: #f5f8fb;
  }
}

.recurrence-box {
  background: #ecf8f4;
  border-radius: 5px;
  margin-top: 14px;
  padding: 14px 16px;

  label {
    display: block;
    margin-bottom: 8px;
  }

  p {
    color: #243047;
    margin: 10px 0 0;
  }
}

.repeat-inline {
  align-items: center;
  display: flex;
  gap: 10px;

  .custom-select {
    max-width: 110px;
  }
}

.section-subtitle {
  color: #657085;
  margin: -8px 0 10px;
}

.reminder-options {
  display: flex;
  gap: 28px;
  margin-bottom: 10px;
}

.reminder-row {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: auto minmax(0, 1fr);

  label {
    margin: 0;
  }
}

.upload-drop {
  align-items: center;
  border: 1px dashed #d5dde8;
  border-radius: 7px;
  color: #465267;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  min-height: 72px;
  padding: 14px;
  text-align: center;

  i {
    color: #465267;
    font-size: 24px;
  }

  span {
    font-weight: 500;
  }

  small {
    color: #657085;
  }

  input {
    display: none;
  }
}

.summary-card {
  padding: 0;

  h2 {
    border-bottom: 1px solid #e7edf4;
    margin: 0;
    padding: 18px 20px;
  }
}

.summary-item,
.summary-dates {
  border-bottom: 1px solid #e7edf4;
  padding: 12px 20px;
}

.summary-item {
  display: grid;
  gap: 4px;

  span {
    color: #657085;
    font-size: 13px;
  }

  strong {
    color: #172033;
    font-size: 14px;
    font-weight: 600;
  }

  button {
    background: transparent;
    border: 0;
    color: #008e75;
    font-weight: 600;
    padding: 0;
    text-align: left;
  }

  .summary-value {
    color: #008e75;
    font-size: 22px;
  }
}

.summary-dates {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  span,
  small {
    color: #657085;
    display: block;
    font-size: 13px;
  }

  strong {
    color: #172033;
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-top: 6px;
  }
}

.receivable-tip {
  background: #eefaf5;

  p {
    color: #243047;
    line-height: 1.5;
    margin: 0;
  }
}

.shortcuts-card {
  button {
    background: transparent;
    border: 0;
    color: #008e75;
    display: block;
    font-weight: 600;
    margin-bottom: 10px;
    padding: 0;
    text-align: left;
  }
}

.quick-create-grid {
  display: grid;
  gap: 12px;

  label,
  legend {
    color: #172033;
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  .form-group {
    margin-bottom: 0;
  }

  .form-control {
    border-color: #d8dee8;
    border-radius: 5px;
    min-height: 40px;
  }
}

.quick-create-actions {
  border-top: 1px solid #e7edf4;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 18px;
  padding-top: 16px;

  .btn {
    align-items: center;
    border-radius: 5px;
    display: inline-flex;
    font-weight: 700;
    justify-content: center;
    margin: 0;
    min-height: 40px;
    min-width: 132px;
  }
}

.history-screen {
  background: #f5f7fb;
  border-radius: 7px;
  display: grid;
  gap: 14px;
  margin-top: 8px;
  padding: 14px;
}

.history-topbar,
.history-actions,
.history-client-card,
.history-client-main,
.history-client-metrics,
.history-kpis,
.history-filters,
.history-table-head,
.history-footer,
.history-send-actions {
  align-items: center;
  display: flex;
}

.history-topbar {
  justify-content: space-between;
}

.history-breadcrumb {
  color: #647084;
  font-size: 12px;
  margin-bottom: 6px;
}

.history-topbar h2 {
  color: #172033;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.history-actions,
.history-send-actions {
  gap: 10px;

  .btn {
    align-items: center;
    border-radius: 5px;
    display: inline-flex;
    gap: 7px;
    height: 36px;
    justify-content: center;
    margin: 0;
  }
}

.history-client-card,
.history-kpis article,
.history-filters,
.history-table-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
}

.history-client-card {
  justify-content: space-between;
  padding: 18px 20px;
}

.history-client-main {
  gap: 14px;
}

.history-company-icon {
  align-items: center;
  background: #e7f5ef;
  border-radius: 7px;
  color: #008e75;
  display: inline-flex;
  font-size: 24px;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.history-client-main strong,
.history-client-main span,
.history-client-main small {
  display: block;
}

.history-client-main strong {
  color: #172033;
  font-weight: 700;
}

.history-client-main span,
.history-client-main small {
  color: #647084;
  font-size: 12px;
  margin-top: 3px;
}

.history-client-metrics {
  border-left: 1px solid #dfe6ef;
  gap: 32px;
  padding-left: 28px;
}

.history-client-metrics div {
  display: grid;
  gap: 2px;
}

.history-client-metrics span,
.history-client-metrics small {
  color: #647084;
  font-size: 12px;
}

.history-client-metrics strong {
  color: #172033;
  font-size: 13px;

  &.is-good {
    color: #008e75;
  }
}

.history-kpis {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.history-kpis article {
  display: grid;
  gap: 8px;
  padding: 16px;
}

.history-kpis span {
  color: #008e75;
  font-size: 12px;
  font-weight: 700;

  &.is-positive {
    color: #008e75;
  }

  &.is-negative {
    color: #dc3545;
  }
}

.history-kpis small {
  color: #647084;
}

.history-kpis strong {
  color: #172033;

  &.is-danger {
    color: #dc3545;
  }
}

.history-filters {
  gap: 10px;
  padding: 10px;

  input,
  select {
    border: 1px solid #d8dee8;
    border-radius: 5px;
    color: #172033;
    height: 34px;
    min-width: 130px;
    padding: 0 10px;
  }

  > span {
    color: #647084;
  }

  > button {
    align-items: center;
    background: #e7f1ef;
    border: 0;
    border-radius: 5px;
    color: #172033;
    display: inline-flex;
    height: 34px;
    justify-content: center;
    width: 34px;
  }
}

.history-search {
  align-items: center;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  display: flex;
  flex: 1;
  gap: 8px;
  height: 34px;
  min-width: 240px;
  padding: 0 10px;

  i {
    color: #647084;
  }

  input {
    border: 0;
    flex: 1;
    height: auto;
    min-width: 0;
    padding: 0;
  }
}

.history-table-card {
  overflow: hidden;
}

.history-table-head {
  justify-content: space-between;
  padding: 16px 18px;

  h3 {
    align-items: center;
    color: #172033;
    display: flex;
    font-size: 15px;
    font-weight: 700;
    gap: 8px;
    margin: 0;
  }

  h3 i {
    color: #008e75;
  }

  span {
    color: #647084;
    font-size: 12px;
  }
}

.history-table-wrap {
  overflow-x: auto;
}

.history-table {
  border-collapse: collapse;
  min-width: 760px;
  width: 100%;

  th {
    background: #eef3fb;
    color: #647084;
    font-size: 12px;
    font-weight: 700;
    padding: 14px;
    text-align: left;
    text-transform: uppercase;
  }

  td {
    border-top: 1px solid #e7edf4;
    color: #172033;
    font-size: 13px;
    padding: 13px 14px;
    vertical-align: middle;
  }

  td strong,
  td span {
    display: block;
  }

  td span {
    color: #647084;
    font-size: 12px;
    margin-top: 2px;
  }

  .is-danger {
    color: #dc3545;
  }
}

.history-status {
  border-radius: 999px;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;

  &.is-aberto {
    background: #e8f1ff;
    color: #1f6feb;
  }

  &.is-pago {
    background: #e7f5ef;
    color: #008e75;
  }

  &.is-atrasado {
    background: #ffe9ed;
    color: #dc3545;
  }
}

.history-more {
  background: transparent;
  border: 0;
  color: #172033;
  font-size: 18px;
}

.history-empty {
  color: #647084;
  text-align: center;
}

.history-footer {
  color: #647084;
  font-size: 12px;
  justify-content: space-between;
  padding: 14px 18px;
}

.history-send-actions {
  justify-content: flex-end;
}

@media (max-width: 1199px) {
  .receivable-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .receivable-dashboard-bottom {
    grid-template-columns: 1fr;
  }

  .receivable-grid {
    grid-template-columns: 1fr;
  }

  .receivable-aside {
    position: static;
  }

  .history-client-card,
  .history-client-metrics,
  .history-topbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .history-client-metrics {
    border-left: 0;
    border-top: 1px solid #dfe6ef;
    gap: 16px;
    padding-left: 0;
    padding-top: 16px;
    width: 100%;
  }

  .history-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .bloco {
    padding: 18px;
  }

  .receivable-page-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .receivable-page-actions .btn {
    width: 100%;
  }

  .receivable-filter-drawer {
    width: 100vw;
  }

  .receivable-filter-actions {
    grid-template-columns: 1fr;
  }

  .receivable-kpi-grid {
    grid-template-columns: 1fr;
  }

  .receivable-list-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .receivable-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .receivable-actions {
    justify-content: flex-start;
    width: 100%;

    .btn {
      flex: 1 1 auto;
      justify-content: center;
    }
  }

  .receivable-form-grid.two-cols,
  .receivable-form-grid.four-cols,
  .receivable-split,
  .summary-dates {
    grid-template-columns: 1fr;
  }

  .input-with-action,
  .value-row,
  .reminder-row {
    grid-template-columns: 1fr;
  }

  .history-actions,
  .history-filters,
  .history-send-actions {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .history-actions .btn,
  .history-send-actions .btn,
  .history-search,
  .history-filters input,
  .history-filters select {
    width: 100%;
  }

  .history-kpis {
    grid-template-columns: 1fr;
  }
}
</style>
